import React from "react";
import { Link } from "react-router-dom";
import { FaLaptopCode, FaRobot, FaLock, FaCube } from "react-icons/fa";


const courses = [
  {
    id: "cyber-security",
    title: "Cyber Security Internship",
    duration: "4 Weeks",
    mode: "Remote",
    color: "from-indigo-500 to-indigo-700",
  },
  {
  id: "python-programming",
  title: "Python Programming Internship",
  duration: "6 Weeks",
  mode: "Remote",
  color: "from-yellow-500 to-orange-600",
},
  {
    id: "ai-ml",
    title: "AI & ML Internship",
    duration: "12 Weeks",
    mode: "Remote",
    color: "from-pink-500 to-purple-600",
  },
  {
    id: "web-dev",
    title: "Web Development Internship",
    duration: "4 Weeks",
    mode: "Hybrid",
    color: "from-blue-500 to-cyan-600",
  },
  {
    id: "blockchain",
    title: "Blockchain Internship",
    duration: "6 Weeks",
    mode: "Remote",
    color: "from-gray-400 to-purple-500",
  },
];

const icons = {
  "cyber-security": <FaLock />,
  "ai-ml": <FaRobot />,
  "web-dev": <FaLaptopCode />,
  "blockchain": <FaCube />,
};

const Courses = () => {
  return (
    <main role="main" className="relative min-h-screen bg-gradient-to-br from-white via-gray-100 to-gray-200 px-6 py-20 text-gray-900 overflow-hidden">

      

      <h2 className="text-3xl font-bold text-center mb-12 text-indigo-600">Internship Courses</h2>

      <section aria-label="Available Courses" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {courses.map((course) => (
          <article
            key={course.id}
            className={`bg-gradient-to-br ${course.color} p-6 rounded-xl shadow-lg transition-transform hover:scale-[1.03] active:scale-[0.98] hover:shadow-2xl flex flex-col animate-gradient`}
          >
            <h3 className="text-xl font-semibold mb-2 flex items-center gap-2 text-white">
              {icons[course.id]} {course.title}
            </h3>
            <p className="text-sm text-gray-100 mb-1">Duration: {course.duration}</p>
            <p className="text-sm text-gray-100 mb-4">Mode: {course.mode}</p>
            <Link
              to={`/courses/${course.id}`}
              aria-label={`View details for ${course.title}`}
              className="mt-auto inline-block bg-white text-indigo-700 px-5 py-2 rounded-md font-semibold hover:bg-indigo-50 transition"
            >
              View Details
            </Link>
          </article>
        ))}
      </section>
    </main>
  );
};

export default Courses;
